module.exports = __webpack_public_path__ + "static/media/CT_2019_30439_8941.a1caff20.png";